import React from 'react';
import PopulationHealthDashboard from '../../components/PopulationHealthDashboard';

/**
 * AdminPopulationHealth — Aggregate anonymized population health analytics.
 */
const AdminPopulationHealth = () => {
  return (
    <div className="py-6">
      <PopulationHealthDashboard />
    </div>
  );
};

export default AdminPopulationHealth;
